import { render, staticRenderFns } from "./CabeceraTabla.vue?vue&type=template&id=74080c76&"
import script from "./CabeceraTabla.vue?vue&type=script&lang=ts&"
export * from "./CabeceraTabla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports